import { render } from "./BaseButton.vue?vue&type=template&id=92804860&scoped=true"
import script from "./BaseButton.vue?vue&type=script&lang=js"
export * from "./BaseButton.vue?vue&type=script&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=92804860&lang=scss"
import "./BaseButton.vue?vue&type=style&index=1&id=92804860&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-92804860"]])

export default __exports__